window.kurzanalyse = {};
window.kurzanalyse.url = '/Handler/HvD/Kurzanalyse';
window.globalstate = {};
window.globalstate.url = '/Handler/HvD/GlobalState';


function init() {

    // editor initialisieren falls noch nicht vorhanden
    if(!document.getElementById('dlg-kurzanalyse-edit') || !window.CKEDITOR) {
        return;
    }
    window.CKEDITOR.disableAutoInline = true;
    if (!document.querySelectorAll('.edit-kurzAnalyse').length && !document.querySelectorAll('i.list-edit-kurzanalyse').length ) {
        return;
    }
    if (!CKEDITOR.instances['edit-kurzAnalyse']) {
        window.CKEDITOR.inline('edit-kurzAnalyse');
    }
    window.dlgEditKurz = $('#dlg-kurzanalyse-edit');
    window.dlgEditKurz.editor = CKEDITOR.instances['edit-kurzAnalyse'];
    window.dlgEditKurz.dialog({
        open: function(event, ui) {
            // Resubmit soll neu gesetzt werden, falls vorhanden. Resubmit + global.resubmission
            $(this).find('.marker').removeClass('active');
            $(this).find('.marker').click(function(event) {
                $(this).toggleClass('active');
                // console.debug($(this).closest('.block.opener'));
            });
        },
        buttons: [{
            text: "Schließen",
            class: "cancel",
            click: function() {
                $(this).find('.marker').off('click');
                $(this).dialog("close");
            }
        }, {
            text: "Speichern",
            class: "ok",
            click: function() {

                var $target = window.dlgEditKurz.target;
                var newData = window.dlgEditKurz.editor.getData();
                var resubmit = $(window.dlgEditKurz).find('.resubmission').val();
                var copyData = [];
                $(this).find('.marker.active').each(function(i, el) {
                    var s = {
                        type: $(el).attr('data-type'),
                        id: $(el).attr('data-id')
                    };
                    copyData.push(s);
                });
                $.ajax({
                    cache: false,
                    type: "POST",
                    url: window.kurzanalyse.url,
                    data: {
                        data: {
                            id: window.dlgEditKurz.owner.attr('data-id'),
                            'resubmit': resubmit,
                            type: window.dlgEditKurz.owner.attr('data-type'),
                            data: newData,
                            copy: copyData
                        }
                    }
                }).done(function(data) {
                    if (data === 'ok') {
                        copyData.forEach( stationIdentifier => {
                            let stationElement = document.querySelector('.row.hvd-min-height[data-type="' + stationIdentifier.type + '"][data-id="'+ stationIdentifier.id +'"] .kurzanalyse-outer .kurzanalyse');
                            if(stationElement) {
                                stationElement.innerHTML = newData;
                            }
                        } );
                        tools.toast('Kurzanalyse', 'Kurzanalyse gespeichert');
                    }
                });
            }
        }],
        autoOpen: false,
        height: 500,
        width: 700,
        modal: false
    });

    $('i.list-edit-kurzanalyse,i.edit-kurzAnalyse').click(function(event) {
        // daten müssen erst geholt werden
        var btn = $(this);
        $.ajax({
            cache: false,
            type: "POST",
            url: window.kurzanalyse.url,
            data: {
                data: {
                    get: 1,
                    id: btn.attr('data-id'),
                    type: btn.attr('data-type')
                }
            }
        }).done(function(data) {
            console.log("OK");
            var resubmit = $(window.dlgEditKurz).find('.resubmission');
            /* Wiedervorlage Datum */
            resubmit.datetimepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd.mm.yy',
                timeFormat: "HH:mm"
            });
            resubmit.datepicker("option", $.datepicker.regional['de']);
            if (btn.attr('data-resubmit') !== '') {
                var nextSubmit = btn.attr('data-nextsubmit');
                if (nextSubmit) {
                    resubmit.val(nextSubmit);
                } else {
                    resubmit.val(btn.attr('data-resubmit'));
                }
            }
            window.dlgEditKurz.editor.setData(data);

        });
        editKurzAnalyse(this, event);
    });

    // WUPSUPP-290

    window.dlgSetStatus = $('#dlg-status-edit')
    if (!CKEDITOR.instances['global-kurzAnalyse']) {
        window.CKEDITOR.inline('global-kurzAnalyse');
    }
    window.dlgSetStatus.editor = CKEDITOR.instances['global-kurzAnalyse'];
    window.dlgSetStatus.dialog({
        open: function(event, ui) {},
        close: function() {
            document.activeElement.blur();
        },
        buttons: [{
            text: "Schließen",
            class: "cancel",
            click: function() {
                $(this).find('.marker').off('click');
                $(this).dialog("close");
                document.activeElement.blur();
            }
        }, {
            text: "Speichern",
            class: "ok",
            click: function() {
                if (!document.querySelector("input[type='radio'][name='globalType']:checked") ||
                    !document.querySelector("input[type='radio'][name='globalState']:checked")
                ) {
                    alert("Stationstype und Status müssen gewählt werden")
                    return;
                }
                $.ajax({
                    cache: false,
                    type: "POST",
                    url: window.globalstate.url,
                    data: {
                        data: {
                            globalType: document.querySelector("input[type='radio'][name='globalType']:checked").value,
                            globalState: document.querySelector("input[type='radio'][name='globalState']:checked").value,
                            htmltext: window.dlgSetStatus.editor.getData()
                        }
                    }
                }).done(function(data) {
                    if (data === 'ok') {
                        tools.toast('Status', 'Status wurde gespeichert');
                        document.body.style.cursor = 'wait';
                        var loader = document.getElementById('loader');
                        setTimeout(function() {
                            loader.querySelector('.content p').innerHTML = 'Bitte warten';
                            loader.style.display = 'block';
                            setTimeout(function() {
                                location.reload();
                            }, 200);
                        }, 100);
                    }
                });
            }
        }],
        autoOpen: false,
        height: 540,
        width: 700,
        modal: false
    });


    document.querySelectorAll('.edit-global-state').forEach( /** @param {HTMLElement} el */ function(el) {
        el.addEventListener('click', /** @param {HTMLElement} ev */ function(ev) {
            window.dlgSetStatus.owner = $(this);
            window.dlgSetStatus.target = $('#global-kurzAnalyse');
            window.dlgSetStatus.editor.setData(window.dlgSetStatus.target.html());
            if (window.dlgSetStatus.textbausteine === undefined) {
                window.dlgSetStatus.textbausteine = $('#globalTextbaustein').selectmenu({
                    width: '100%',
                    change: function(event, ui) {
                        $.ajax({
                            cache: false,
                            type: "POST",
                            url: '/Handler/HvD/Textblock',
                            data: {
                                'type': 'get',
                                id: ui.item.value
                            }
                        }).done(function(data) {
                            window.dlgSetStatus.editor.setData(data);
                        });
                    }
                });
            } else {
                $('#globalTextbaustein').val(-1);
                $('#globalTextbaustein').selectmenu('refresh');
            }
            ev.stopPropagation();
            ev.preventDefault();
            window.dlgSetStatus.dialog('open');
        });
    });

}

/**
 * Kurzanalyse bearbeiten
 * @param {object} owner
 * @param {event} event
 */
window.editKurzAnalyse = (owner, event) => {
    window.dlgEditKurz.owner = $(owner);
    window.dlgEditKurz.target = window.dlgEditKurz.owner.parents('.kurzanalyse-outer').find('.kurzanalyse');
    window.dlgEditKurz.editor.setData(window.dlgEditKurz.target.html());
    window.dlgEditKurz.dialog('open');
    if (window.dlgEditKurz.textbausteine === undefined) {
        window.dlgEditKurz.textbausteine = $('#kurzTextbaustein').selectmenu({
            width: '100%',
            change: function(event, ui) {
                $.ajax({
                    cache: false,
                    type: "POST",
                    url: '/Handler/HvD/Textblock',
                    data: {
                        'type': 'get',
                        id: ui.item.value
                    }
                }).done(function(data) {
                    window.dlgEditKurz.editor.setData(window.dlgEditKurz.editor.getData() + data);
                });
            }
        });
    } else {
        $('#kurzTextbaustein').val(-1);
        $('#kurzTextbaustein').selectmenu('refresh');
    }
}


/**
 * Kurzanalyse abrufen nach Stations-wechsel
 * @param {object} item Whom to greet.
 */
window.KAstationChange = (item) => {
    window.dlgEditKurz.target = $(item).parents('.kurzanalyse-outer').find('.kurzanalyse');
    var btn = item[0].parentElement.querySelector('.edit-kurzAnalyse');
    btn.dataset.id = item.find('option:selected').data('id');
    $.ajax({
        cache: false,
        type: "POST",
        url: window.kurzanalyse.url,
        data: {
            data: {
                get: 1,
                id: btn.dataset.id,
                type: item[0].dataset.type
            }
        }
    }).done(function(data) {
        window.dlgEditKurz.target.html(data);
    });
}
window.setTimeout(init, 200);
